import { useEffect, useRef } from 'react'
import { useWatch } from 'react-hook-form'
import { useCheckout } from 'src/public/components/online_ordering/CheckoutContext'

/**
 * Custom hook that resets the disableAccountCreation flag when the phone number changes.
 * This allows users to retry account creation after fixing their phone number if it was
 * previously disabled due to an error (e.g., deactivated phone).
 */
export const useResetDisableAccountCreation = () => {
  const phoneNumber = useWatch({ name: 'yourInfoPhone' })
  const { disableAccountCreation, setDisableAccountCreation } = useCheckout()
  const prevPhoneNumberRef = useRef(phoneNumber)

  useEffect(() => {
    if (
      prevPhoneNumberRef.current !== phoneNumber &&
      prevPhoneNumberRef.current !== undefined &&
      disableAccountCreation
    ) {
      setDisableAccountCreation(false)
    }
    prevPhoneNumberRef.current = phoneNumber
  }, [phoneNumber, setDisableAccountCreation, disableAccountCreation])
}
